module.exports = __webpack_public_path__ + "fonts/Roboto-Light.dd9e8e4.woff";